<template>
  <div v-if="donation" class="donation-card" @click="onClick">
    <div v-if="selected">
      <!-- class small-load-spinner is used to adjust the size of the loadspinner to fit the ActivityCard  -->
      <LoadSpinner :color="`#${organizationDetails.darkBrandColor}`" />
    </div>
    <template v-else>
      <!-- Active donation -->
      <div v-if="donation.isSubscriptionActive" class="fcolumn">
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name" v-translate>Amount</div>
            <div class="field-value">{{ donation.amount | currency }}</div>
          </div>
          <div class="form-field-container">
            <div class="field-name">{{ $gettext('Status:') }}</div>
            <div class="field-value">
              <translate>Active</translate>
            </div>
          </div>
        </div>
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name" v-translate>Date</div>
            <div class="field-value">
              {{ donation.mostRecentRecurringDate | formatDateShort($language.current) }}
            </div>
          </div>
        </div>
      </div>

      <!-- Canceled donation -->
      <div v-else class="fcolumn">
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name">{{ $gettext('Status:') }}</div>
            <div class="field-value">
              <translate>Canceled</translate>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoadSpinner from '@/components/LoadSpinner'

export default {
  name: 'ActivityCard',
  components: {
    LoadSpinner,
  },
  data() {
    return {
      selected: false,
      language: this.$store.state.user ? this.$store.state.user.preferredLanguage : 'en',
    }
  },
  props: {
    donation: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async onClick() {
      this.selected = true
      if (this.donation.subscriptionId) {
        this.$router.push({
          name: 'DonationSummary',
          params: { subscriptionId: this.donation.subscriptionId },
        })
      } else {
        this.$router.push({
          name: 'DonationSummary',
          params: { id: this.donation.id },
        })
      }
      this.selected = false
    },
  },
  computed: {
    ...mapState(['organizationDetails']),
    formattedActivity() {
      let icon = require('@/assets/icons/donate.png')
      return Object.assign(this.donation, { icon: icon })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/flex-box';

.donation-card {
  cursor: pointer;
  padding: 1rem 0.5rem;

  &:hover {
    background-color: #f0f0f0;
  }
}

.form-field {
  padding: 0;
  margin-bottom: 1rem;

  .form-field-container {
    flex: 1;
  }

  &:last-of-type {
    margin-bottom: 0rem;
  }
}
</style>
